const BASE = "/api/"

const getEnvVar = (value: string | undefined, fallback: string) => value?.trim() || fallback

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, "")

const normalizeSiteUrl = (url: string) => `${normalizeBaseUrl(url)}/`

const URL_API = normalizeBaseUrl(getEnvVar(import.meta.env.VITE_API_URL, "https://catalojei.com.br"))

const SITE = normalizeSiteUrl(getEnvVar(import.meta.env.VITE_SITE_URL, "https://catalojei.com.br"))

export const API_ROUTES = {
  URL_API,
  SITE,

  TOKEN: "STF-X",
  TOKEN_CUSTOMER: "STF-X-C",
  TOKEN_COURIER: "STF-C-C",
  TOKEN_ADMIN: "STF-X-A",
  TOKEN_SERVICE_POINT_SELF_SERVICE: "STF-X-SERVICE-POINT",
  TOKEN_RESELLER: "STF-X-R",

  EMAIL_KEY: "STF-X-MAIL",
  KEY: "API-ORDER-PRO-WEB",

  HUB: {
    DELIVERY: `${URL_API}/hubs/delivery`,
    WHATSAPP_PANEL: `${URL_API}/hubs/whatsapp-panel`,
  },

  PWA: {
    GET_PUBLIC_KEY: `${BASE}pwa/public-key`,
    SUBSCRIBE: `${BASE}pwa/subscribe`,
    UNSUBSCRIBE: `${BASE}pwa/unsubscribe`,
  },

  OPERATIONAL_HELP: {
    ASK: `${BASE}operational-help/ask`,
  },

  AUTH: {
    LOGIN: `${BASE}Authentication`,
    LOGIN_GOOGLE: `${BASE}Authentication/google`,
    ADMIN_LOGIN: `${BASE}AdminAuth/login`,
    RESELLER_LOGIN: `${BASE}ResellerAuth/login`,
    RESELLER_SIGNUP: `${BASE}ResellerAuth/signup`,
    RESELLER_SEND_RECOVER_LINK: `${BASE}ResellerAuth/recover-password`,
    SEND_RECOVER_LINK: `${BASE}RecoverPassword/send`,
    TRY_CHANGE_PASSWORD: `${BASE}RecoverPassword/try-change-password`,
    RESET_PASSWORD: `${BASE}ChangePassword/try-change-password`,
    RESET_PASSWORD_BY_ADMIN: `${BASE}ChangePassword/change-user-password-by-admin`,

    LOGIN_CUSTOMER: (slug: string) => `/${slug}${BASE}Account/activate-customer`,
    CREATE_LOGIN_CUSTOMER: (slug: string) => `/${slug}${BASE}Account/create-customer`,
  },

  CONTRACT: {
    DOWNLOAD: `${BASE}contract/download`,
  },

  ACCOUNT: {
    CREATE: `${BASE}account`,
    CREATE_WITH_GOOGLE: `${BASE}account/google`,
    COMPLETE_OWNER_PROFILE: `${BASE}account/owner-profile/complete`,
    GET: `${BASE}account`,
    GET_ALL: `${BASE}account`,
    DELETE: `${BASE}account`,
    PUT: `${BASE}account`,
  },

  PRINT: {
    TO_CUSTOMER: `${BASE}print/print`,
    TO_FULFILLMENT: `${BASE}print/print-fulfillment`,
    TO_PRINTER: `${BASE}print/print-to-printer`,
  },

  PRINT_AUTOMATION: {
    OVERVIEW: `${BASE}print-automation/overview`,
    GENERATE_PAIRING_CODE: `${BASE}print-automation/pairing-code`,
    PRINTERS: `${BASE}print-automation/printers`,
    TEST_PRINT: (printerConfigurationId: number) => `${BASE}print-automation/test-print/${printerConfigurationId}`,
    DELETE_AGENT: (agentId: number) => `${BASE}print-automation/agents/${agentId}`,
  },

  WHATSAPP_AUTOMATION: {
    OVERVIEW: `${BASE}whatsapp-automation/overview`,
    CRM_OVERVIEW: `${BASE}whatsapp-automation/crm/overview`,
    GENERATE_PAIRING_CODE: `${BASE}whatsapp-automation/pairing-code`,
    INSTALLER: `${BASE}whatsapp-automation/installer`,
    DOWNLOAD_AGENT: `${URL_API}/downloads/whatsapp-agent/orderpro-whatsapp-agent.zip`,
    SEND_MESSAGE: `${BASE}whatsapp-automation/send-message`,
    CRM_SEND_MESSAGE: `${BASE}whatsapp-automation/crm/send-message`,
    AI_MESSAGE_SETTINGS: `${BASE}whatsapp-automation/ai-message-settings`,
    CRM_CONVERSATIONS: `${BASE}whatsapp-automation/crm/conversations`,
    CRM_MESSAGES: (remotePhone: string) =>
      `${BASE}whatsapp-automation/crm/conversations/${encodeURIComponent(remotePhone)}/messages`,
    DELETE_AGENT: (agentId: number) => `${BASE}whatsapp-automation/agents/${agentId}`,
  },

  PLATFORM_WHATSAPP: {
    OVERVIEW: `${BASE}admin/platform-whatsapp/overview`,
    GENERATE_PAIRING_CODE: `${BASE}admin/platform-whatsapp/pairing-code`,
    DELETE_AGENT: (agentId: number) => `${BASE}admin/platform-whatsapp/agents/${agentId}`,
    SETTINGS: `${BASE}admin/platform-whatsapp/settings`,
    CONVERSATIONS: `${BASE}admin/platform-whatsapp/conversations`,
    MESSAGES: (conversationId: number) => `${BASE}admin/platform-whatsapp/conversations/${conversationId}/messages`,
    CONVERSATION: (conversationId: number) => `${BASE}admin/platform-whatsapp/conversations/${conversationId}`,
    KNOWLEDGE: `${BASE}admin/platform-whatsapp/knowledge`,
    DELETE_KNOWLEDGE: (id: number) => `${BASE}admin/platform-whatsapp/knowledge/${id}`,
  },

  AI_INTEGRATION: {
    SETTINGS: `${BASE}ai-integration/settings`,
    ASK: `${BASE}ai-integration/ask`,
  },

  RESPOSTA_AI_INTEGRATION: {
    SETTINGS: `${BASE}resposta-ai-integration/settings`,
    GLOBAL_KEY: `${BASE}resposta-ai-integration/global-key`,
    INSTANCES: `${BASE}resposta-ai-integration/instances`,
    PROVISION: `${BASE}resposta-ai-integration/provision`,
    ACTIVATE: `${BASE}resposta-ai-integration/activate`,
    SYNC_KNOWLEDGE: `${BASE}resposta-ai-integration/sync-knowledge`,
  },

  FISCAL_INTEGRATION: {
    SETTINGS: `${BASE}fiscal-integration/settings`,
    ISSUER_SETTINGS: `${BASE}fiscal-integration/settings/issuer`,
    TEST_CONNECTION: `${BASE}fiscal-integration/settings/test`,
    PRODUCTS: `${BASE}fiscal-integration/products`,
    PRODUCT: (productId: number) => `${BASE}fiscal-integration/products/${productId}`,
    PRODUCTS_BULK: `${BASE}fiscal-integration/products/bulk`,
    DOCUMENTS: `${BASE}fiscal-integration/documents?take=100`,
    SEARCH_DOCUMENTS: `${BASE}fiscal-integration/documents/search`,
    ORDER_EMISSION_STATUS: (orderId: number) => `${BASE}fiscal-integration/orders/${orderId}/emission-status`,
    EMIT_ORDER: (orderId: number) => `${BASE}fiscal-integration/orders/${orderId}/emit`,
    RETRY: (documentId: number) => `${BASE}fiscal-integration/documents/${documentId}/retry`,
    REFRESH: (documentId: number) => `${BASE}fiscal-integration/documents/${documentId}/refresh`,
    CANCEL: (documentId: number) => `${BASE}fiscal-integration/documents/${documentId}/cancel`,
    XML: (documentId: number) => `${BASE}fiscal-integration/documents/${documentId}/xml`,
    PRINT: (documentId: number, printerConfigurationId: number) =>
      `${BASE}fiscal-integration/documents/${documentId}/print/${printerConfigurationId}`,
    IMPORTED_DOCUMENTS: `${BASE}fiscal-integration/imported-documents`,
    IMPORTED_DOCUMENT_DOWNLOAD: (documentId: number) =>
      `${BASE}fiscal-integration/imported-documents/${documentId}/download`,
    IMPORTED_DOCUMENT_DELETE: (documentId: number) => `${BASE}fiscal-integration/imported-documents/${documentId}`,
    IMPORTED_DOCUMENT_EXPORT: `${BASE}fiscal-integration/imported-documents/export`,
  },

  AWARD: {
    CREATE: `${BASE}award`,
    GET: `${BASE}award`,
    GET_ALL: `${BASE}award`,
    DELETE: `${BASE}award`,
    PUT: `${BASE}award`,
    APPLY: `${BASE}award/apply`,
    APPLY_REMOVE: `${BASE}award/apply`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}award/public`,
  },

  COMPANY: {
    UPDATE_SERVICE_POINT_SELF_SERVICE: `${BASE}company/service-point-self-service`,
    UPDATE_DEFAULT_SERVICE_POINT: `${BASE}company/default-service-point`,
    CREATE: `${BASE}company`,
    GET: `${BASE}company`,
    GET_ALL: `${BASE}company`,
    DELETE: `${BASE}company`,
    PUT: `${BASE}company`,
    UPDATE_OPERATING_SCHEDULE: `${BASE}company/operating-schedule`,
    UPDATE_SLUG: `${BASE}company/update-slug`,
    UPDATE_PUBLIC_MENU_DESIGN: `${BASE}company/public-menu-design`,
    PUBLIC_MENU_THEMES: `${BASE}company/public-menu-themes`,
    UPDATE_PUBLIC_MENU_TRACKING: `${BASE}company/public-menu-tracking`,
    GET_ACTIVE_PUBLIC_STORES: `${BASE}company/public-stores`,
    GET_MODULES: (companyId: number) => `${BASE}company/modules/${companyId}`,
    UPDATE_MODULES: (companyId: number) => `${BASE}company/modules/${companyId}`,

    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}company/public`,
  },

  STORE_GROUPS: {
    GET_ALL: `${BASE}store-groups`,
    CREATE: `${BASE}store-groups`,
    UPDATE: (groupId: number) => `${BASE}store-groups/${groupId}`,
    DELETE: (groupId: number) => `${BASE}store-groups/${groupId}`,
    INVITES: `${BASE}store-groups/invites`,
    INVITE: (groupId: number) => `${BASE}store-groups/${groupId}/invites`,
    ACCEPT_INVITE: (memberId: number) => `${BASE}store-groups/invites/${memberId}/accept`,
    REJECT_INVITE: (memberId: number) => `${BASE}store-groups/invites/${memberId}/reject`,
    REVOKE_MEMBER: (memberId: number) => `${BASE}store-groups/members/${memberId}/revoke`,
    PUBLIC: (slug: string) => `${BASE}store-groups/public/${slug}`,
  },

  CUSTOMER: {
    CREATE: `${BASE}customer`,
    GET: `${BASE}customer`,
    GET_ALL: `${BASE}customer`,
    DELETE: `${BASE}customer`,
    PUT: `${BASE}customer`,
    EXIT_CHECK: `${BASE}customer/exit-check`,

    GET_UPDATED_CUSTOMER_PUBLIC: `${BASE}customer/get-updated-customer`,
    PUT_CUSTOMER_ADDRESS_PUBLIC: (slug: string) => `/${slug}${BASE}customer/edite-address`,
    PUT_CUSTOMER_PUBLIC: (slug: string) => `/${slug}${BASE}customer/edite`,
    HAS_CUSTOMER_PUBLIC: (slug: string) => `/${slug}${BASE}customer/hasAccount`,
  },

  CATALOG_ITEM: {
    CREATE: `${BASE}catalog-item`,
    GET: `${BASE}catalog-item`,
    GET_ALL: `${BASE}catalog-item`,
    DELETE: `${BASE}catalog-item`,
    PUT: `${BASE}catalog-item`,
    SELECTION_STOCK: `${BASE}catalog-item/selection-stock`,
    ADDITIONAL_STOCK: `${BASE}catalog-item/additional-stock`,

    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}catalog-item/public`,
  },

  PRODUCT: {
    CREATE: `${BASE}product`,
    GET: `${BASE}product`,
    GET_ALL: `${BASE}product`,
    DELETE: `${BASE}product`,
    PUT: `${BASE}product`,
    QUICK_EDIT: `${BASE}product/quick-edit`,
    SELECTION_STOCK: `${BASE}product/selection-stock`,
    ADDITIONAL_STOCK: `${BASE}product/additional-stock`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}product/public`,
  },

  EMPLOYEE: {
    CREATE: `${BASE}employee`,
    GET: `${BASE}employee`,
    GET_ALL: `${BASE}employee`,
    DELETE: `${BASE}employee`,
    PUT: `${BASE}employee`,
    RULES: `${BASE}employee/update-rules`,
    COMPLETE_OWNER_ONBOARDING: `${BASE}employee/owner-onboarding/complete`,
    COMPLETE_MODULE_SETUP: `${BASE}employee/module-setup/complete`,
  },

  EXTRA_SERVICE: {
    CREATE: `${BASE}ExtraService`,
    GET: `${BASE}ExtraService`,
    GET_ALL: `${BASE}ExtraService`,
    DELETE: `${BASE}ExtraService`,
    PUT: `${BASE}ExtraService`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}ExtraService/public`,
  },

  COMBO: {
    CREATE: `${BASE}combo`,
    GET: `${BASE}combo`,
    GET_ALL: `${BASE}combo`,
    DELETE: `${BASE}combo`,
    PUT: `${BASE}combo`,
    SELECTION_STOCK: `${BASE}combo/selection-stock`,
    ADDITIONAL_STOCK: `${BASE}combo/additional-stock`,

    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}combo/public`,
  },

  IMAGE_LIBRARY: {
    CREATE: `${BASE}image-library`,
    CREATE_EXTERNAL: `${BASE}image-library/external`,
    GET_ALL: `${BASE}image-library`,
    CONTENT: (id: number) => `${BASE}image-library/${id}/content`,
    DELETE: (id: number) => `${BASE}image-library/${id}`,
  },

  DATA_IMPORT: {
    SCHEMA: (target: string) => `${BASE}data-import/${target}/schema`,
    TEMPLATE: (target: string, format: string) => `${BASE}data-import/${target}/template?format=${format}`,
    VALIDATE: (target: string) => `${BASE}data-import/${target}/validate`,
    COMMIT: (target: string) => `${BASE}data-import/${target}/commit`,
  },

  CATEGORY: {
    CREATE: `${BASE}category`,
    GET: `${BASE}category`,
    GET_ALL: `${BASE}category`,
    DELETE: `${BASE}category`,
    PUT: `${BASE}category`,

    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}category/public`,
  },

  ADDTIONAL: {
    CREATE: `${BASE}addtional`,
    GET: `${BASE}addtional`,
    GET_ALL: `${BASE}addtional`,
    DELETE: `${BASE}addtional`,
    PUT: `${BASE}addtional`,
    APPLY: `${BASE}addtional/apply`,
    APPLY_REMOVE: `${BASE}addtional/apply`,

    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}addtional/public`,
  },

  SELECTION: {
    CREATE: `${BASE}selection`,
    GET: `${BASE}selection`,
    GET_ALL: `${BASE}selection`,
    DELETE: `${BASE}selection`,
    PUT: `${BASE}selection`,
    APPLY: `${BASE}selection/apply`,
    APPLY_REMOVE: `${BASE}selection/apply`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}selection/public`,
  },

  ORDER: {
    CREATE: `${BASE}order`,
    GET: `${BASE}order`,
    GET_ALL: `${BASE}order`,
    GET_ALL_RESERVED: `${BASE}order/reserved`,
    GET_ALL_NEGOTIATION: `${BASE}order/negotiation`,
    GET_FULFILLMENT_COUNTERS_LEGACY: `${BASE}order/fulfillment-counters`,
    GET_FULFILLMENT_COUNTERS: `${BASE}order/fulfillment-counters`,
    GET_OPEN_BY_SERVICE_POINT: (servicePointId: number) => `${BASE}order/service-point/${servicePointId}/open`,
    DELETE: `${BASE}order`,
    PUT: `${BASE}order`,
    PAY: `${BASE}order/pay`,
    CANCEL: `${BASE}order/cancel`,
    UPDATE_DELIVERY_STATUS: `${BASE}order/update-order-status`,
    UPDATE_DELIVERY_ITEM_STATUS: `${BASE}order/update-order-status-product`,
    UPDATE_FULFILLMENT_STATUS: `${BASE}order/update-fulfillment-status`,
    UPDATE_ORDER_ITEM_STATUS: `${BASE}order/update-order-item-status`,

    CREATE_PUBLIC: (slug: string) => `/${slug}${BASE}order/public`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}order/public`,
    CREATE_SERVICE_POINT_SELF_SERVICE: (slug: string) => `/${slug}${BASE}order/service-point-self-service`,
    GET_SERVICE_POINT_SELF_SERVICE_OPEN: (slug: string) => `/${slug}${BASE}order/service-point-self-service/open`,
    CANCEL_SERVICE_POINT_SELF_SERVICE: (slug: string, orderId: number) =>
      `/${slug}${BASE}order/service-point-self-service/${orderId}/cancel`,
  },

  MANUAL_EXTERNAL_ORDER: {
    CREATE: `${BASE}ManualExternalOrder`,
    GET_ALL: `${BASE}ManualExternalOrder`,
    GET: (id: number) => `${BASE}ManualExternalOrder/${id}`,
    UPDATE: (id: number) => `${BASE}ManualExternalOrder/${id}`,
    CANCEL: (id: number) => `${BASE}ManualExternalOrder/${id}/cancel`,
    FINANCIAL_SUMMARY: `${BASE}ManualExternalOrder/financial-summary`,
  },

  PROMOTION: {
    CREATE: `${BASE}promotion`,
    GET: `${BASE}promotion`,
    GET_ALL: `${BASE}promotion`,
    DELETE: `${BASE}promotion`,
    PUT: `${BASE}promotion`,
    APPLY: `${BASE}promotion/apply`,
    APPLY_REMOVE: `${BASE}promotion/apply`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}promotion/public`,
  },

  NOTICE: {
    CREATE: `${BASE}notice`,
    GET: `${BASE}notice`,
    GET_ALL: `${BASE}notice`,
    DELETE: `${BASE}notice`,
    PUT: `${BASE}notice`,
    GET_ALL_PUBLIC: (slug: string) => `/${slug}${BASE}notice/public`,
  },

  PLATFORM_NOTICE: {
    ADMIN_GET_ALL: `${BASE}platform-notices/admin`,
    ADMIN_RECIPIENTS: `${BASE}platform-notices/admin/recipients`,
    ADMIN_CREATE: `${BASE}platform-notices/admin`,
    ADMIN_UPDATE: (id: number) => `${BASE}platform-notices/admin/${id}`,
    ADMIN_DELETE: (id: number) => `${BASE}platform-notices/admin/${id}`,
    INBOX: `${BASE}platform-notices/inbox`,
    UNREAD_COUNT: `${BASE}platform-notices/unread-count`,
    READ: (id: number) => `${BASE}platform-notices/${id}/read`,
    READ_ALL: `${BASE}platform-notices/read-all`,
  },

  COUPON: {
    CREATE: `${BASE}coupon`,
    GET: `${BASE}coupon`,
    GET_ALL: `${BASE}coupon`,
    DELETE: `${BASE}coupon`,
    PUT: `${BASE}coupon`,
    VALIDATE: `${BASE}coupon/validate`,
  },

  META_INTEGRATION: {
    GET: `${BASE}MetaIntegration`,
    SAVE: `${BASE}MetaIntegration`,
    TOGGLE: `${BASE}MetaIntegration/toggle`,
    UPDATE_NOTIFICATION_PREFERENCES: `${BASE}MetaIntegration/notification-preferences`,
    TEST_CONNECTION: `${BASE}MetaIntegration/test-connection`,
    SEND_WHATSAPP: `${BASE}MetaIntegration/send-whatsapp`,
    REGISTER_PHONE_NUMBER: `${BASE}MetaIntegration/register-phone-number`,
    CHECK_PHONE_NUMBER_STATUS: `${BASE}MetaIntegration/check-phone-number-status`,
    TEMPLATE_STATUSES: `${BASE}MetaIntegration/template-statuses`,
    SYNC_TEMPLATE: `${BASE}MetaIntegration/sync-template`,
  },

  PAYMENT: {
    SUBSCRIPTION_PURCHASE: `${BASE}payment/subscription/purchase`,
    SUBSCRIPTION_PURCHASE_STATUS: (chargeId: number) => `${BASE}payment/subscription/purchase/${chargeId}/status`,
    SUBSCRIPTION_COUPON_VALIDATE: `${BASE}payment/subscription/coupon/validate`,
    SUBSCRIPTION_CANCEL: `${BASE}payment/subscription/cancel`,
    SUBSCRIPTION_SUPPORT: `${BASE}payment/subscription/support`,
    SUBSCRIPTION_VALIDATE_RESELLER_CODE: `${BASE}payment/subscription/reseller-code/validate`,
    SUBSCRIPTION_MANUAL_ACTIVATE: (subscriptionId: number) =>
      `${BASE}payment/subscription/manual-activate/${subscriptionId}`,
    STORE_OAUTH_LINK: `${BASE}payment/mercadopago/oauth/store/authorization-link`,
    STORE_OAUTH_UNLINK: `${BASE}payment/mercadopago/oauth/store/unlink`,
    ORDER_ONLINE_CHECKOUT: `${BASE}payment/order/online-checkout`,
    ORDER_ONLINE_CHECKOUT_PROVIDERS: `${BASE}payment/order/online-checkout/providers`,
    ORDER_TAP_TO_PAY_START: `${BASE}payment/order/tap-to-pay`,
    ORDER_TAP_TO_PAY_STATUS: (chargeId: number) => `${BASE}payment/order/tap-to-pay/${chargeId}/status`,
  },

  ORDER_PAYMENT_PROVIDER: {
    LIST: `${BASE}orderpaymentprovider`,
    UPDATE_CAPABILITIES: `${BASE}orderpaymentprovider`,
    TAP_TO_PAY_DEVICES_LIST: `${BASE}orderpaymentprovider/tap-to-pay/devices`,
    TAP_TO_PAY_DEVICES_UPSERT: `${BASE}orderpaymentprovider/tap-to-pay/devices`,
    MERCADOPAGO_POINT_DEVICES: `${BASE}orderpaymentprovider/mercadopago/point-devices`,
  },

  SUBSCRIPTION: {
    PLANS: `${BASE}subscription/plans`,
    USAGE: `${BASE}subscription/usage`,
    PUBLIC_ORDER_AVAILABILITY: (slug: string) => `/${slug}${BASE}subscription/public-order-availability`,
    BILLING_STATUS: `${BASE}subscription/billing-status`,
  },

  ADMIN_DASHBOARD: {
    GET: `${BASE}AdminDashboard`,
    GET_FINANCIAL_METRICS: `${BASE}AdminDashboard/financial-metrics`,
    GET_RUNTIME: `${BASE}AdminDashboard/runtime`,
    GET_LOGS: `${BASE}AdminDashboard/logs`,
    DOWNLOAD_LOG: (relativePath: string) =>
      `${BASE}AdminDashboard/logs/download?relativePath=${encodeURIComponent(relativePath)}`,
    DELETE_LOG: (relativePath: string) => `${BASE}AdminDashboard/logs?relativePath=${encodeURIComponent(relativePath)}`,
    GET_SUBSCRIPTION_MONITORING_DETAILS: (companyId: number) =>
      `${BASE}AdminDashboard/subscription-monitoring/${companyId}`,
    TOGGLE_COMPANY_TEST_OR_DEMO: (companyId: number) => `${BASE}AdminDashboard/companies/${companyId}/test-or-demo`,
    UPDATE_SUBSCRIPTION: (subscriptionId: number) => `${BASE}AdminDashboard/subscriptions/${subscriptionId}`,
    MERCADO_PAGO_QUERY: `${BASE}AdminDashboard/mercado-pago/query`,
  },

  ADMIN_EMPLOYEE: {
    CREATE: `${BASE}AdminEmployee`,
    GET_ALL: `${BASE}AdminEmployee`,
    PUT: (id: number) => `${BASE}AdminEmployee/${id}`,
    RULES: (id: number) => `${BASE}AdminEmployee/${id}/update-rules`,
    CHANGE_PASSWORD: (id: number) => `${BASE}AdminEmployee/${id}/change-password`,
    ME: `${BASE}AdminEmployee/me`,
  },

  RESELLER: {
    ME: `${BASE}Reseller/me`,
    COMPLETE_PROFILE: `${BASE}Reseller/profile/complete`,
    UPDATE_PROFILE: `${BASE}Reseller/profile`,
    OVERVIEW: `${BASE}Reseller/overview`,
    CLIENTS: `${BASE}Reseller/clients`,
    COMMISSIONS: `${BASE}Reseller/commissions`,
    COUPONS: `${BASE}Reseller/coupons`,
  },

  ADMIN_PLAN: {
    GET_ALL: `${BASE}AdminPlan`,
    CREATE: `${BASE}AdminPlan`,
    UPDATE: (planId: number) => `${BASE}AdminPlan/${planId}`,
    UPDATE_PERIOD: (planPeriodId: number) => `${BASE}AdminPlan/periods/${planPeriodId}`,
    CREATE_PERIOD: (planId: number) => `${BASE}AdminPlan/${planId}/periods`,
    GET_ALL_COUPONS: `${BASE}AdminPlan/coupons`,
    CREATE_COUPON: `${BASE}AdminPlan/coupons`,
    UPDATE_COUPON: (couponId: number) => `${BASE}AdminPlan/coupons/${couponId}`,
    DEACTIVATE_COUPON: (couponId: number) => `${BASE}AdminPlan/coupons/${couponId}/deactivate`,
    APPROVE_COUPON: (couponId: number) => `${BASE}AdminPlan/coupons/${couponId}/approve`,
    REJECT_COUPON: (couponId: number) => `${BASE}AdminPlan/coupons/${couponId}/reject`,
  },

  ADMIN_RESELLER: {
    GET_ALL: `${BASE}AdminReseller`,
    GET_BY_ID: (resellerId: number) => `${BASE}AdminReseller/${resellerId}`,
    UPDATE_STATUS: (resellerId: number) => `${BASE}AdminReseller/${resellerId}/status`,
    ASSIGN_COMMISSION_PLAN: (resellerId: number) => `${BASE}AdminReseller/${resellerId}/commission-plan`,
    GET_ALL_COMMISSION_PLANS: `${BASE}AdminReseller/commission-plans`,
    CREATE_COMMISSION_PLAN: `${BASE}AdminReseller/commission-plans`,
    UPDATE_COMMISSION_PLAN: (planId: number) => `${BASE}AdminReseller/commission-plans/${planId}`,
    MARK_COMMISSION_ENTRY_PAID: (commissionEntryId: number) =>
      `${BASE}AdminReseller/commission-entries/${commissionEntryId}/mark-paid`,
    CREATE_COMMISSION_PAYMENT: (resellerId: number) => `${BASE}AdminReseller/${resellerId}/commission-payments`,
  },

  ADMIN_GROWTH_INVESTMENT: {
    GET_DASHBOARD: `${BASE}AdminGrowthInvestment`,
    CREATE: `${BASE}AdminGrowthInvestment`,
    UPDATE: (id: number) => `${BASE}AdminGrowthInvestment/${id}`,
  },

  TUTORIAL: {
    GET_ALL: `${BASE}tutorial`,
    PUBLIC_GET_ALL: `${BASE}tutorial/public`,
  },

  ADMIN_TUTORIAL: {
    GET_ALL: `${BASE}tutorial/get-all-admin`,
    CREATE: `${BASE}tutorial`,
    UPDATE: (id: number) => `${BASE}tutorial/${id}`,
    DELETE: (id: number) => `${BASE}tutorial/${id}`,
  },

  LANDING: {
    GET_INTEGRATIONS: `${BASE}landing/integrations`,
    GET_TRACKING: `${BASE}landing/tracking`,
    GET_VIDEOS: `${BASE}landing/videos`,
    GET_CONTACT: `${BASE}landing/contact`,
  },
  LANDING_LEAD: {
    CREATE: `${BASE}landinglead`,
    ADMIN_GET_ALL: `${BASE}landinglead/admin`,
    ADMIN_UPDATE_CONTACT_STATUS: (id: number) => `${BASE}landinglead/admin/${id}/contact-status`,
  },

  DELIVERY: {
    BASE: `${BASE}delivery`,
    CALCULATE_SHIPPING_FELL: `${BASE}delivery/shipping/calculate`,
    GET_ALL: `${BASE}delivery/couriers`,
    COURIER_PENDING: `${BASE}delivery/courier/pending`,
    COURIER_ROUTE_PLAN: `${BASE}delivery/courier/route-plan`,
    RESTAURANT_COURIER_ROUTE_PLAN: (courierId: string) => `${BASE}delivery/couriers/${courierId}/route-plan`,
    ASSIGN: `${BASE}delivery/assign`,
    COURIER_LINK: `${BASE}delivery/couriers/link`,
    COURIER_UNLINK: `${BASE}CourierAuth/couriers/unlink`,
    COURIER_REGISTER: `${BASE}CourierAuth/register`,
    COURIER_LOGIN: `${BASE}CourierAuth/login`,
    PUT_COURIER_STATUS: `${BASE}CourierAuth/couriers/online`,
    GET_COURIER_UPDATED: `${BASE}CourierAuth`,
    UPDATE_COURIER_PROFILE: `${BASE}CourierAuth/profile`,
    UPDATE_COURIER_PASSWORD: `${BASE}CourierAuth/password`,
    SEND_COURIER_RECOVER_LINK: `${BASE}CourierAuth/recover-password/send`,
    TRY_CHANGE_COURIER_PASSWORD: `${BASE}CourierAuth/recover-password/try-change-password`,
  },

  COURIER_PAYMENT: {
    BASE: `${BASE}delivery`,
    COURIER_FINANCIAL_SUMMARY: `${BASE}delivery/courier/financial-summary`,
    STORE_PAYMENT_CONTROL: `${BASE}delivery/store/courier-payment-control`,
    STORE_PAYMENT_STATEMENT: `${BASE}delivery/store/courier-payments`,
    CREATE_COURIER_PAYMENT: `${BASE}delivery/store/courier-payments`,
    CONFIRM_COURIER_PAYMENT: (paymentId: number) => `${BASE}delivery/courier-payments/${paymentId}/confirmation`,
  },

  SERVICE_POINT: {
    CREATE: `${BASE}service-point`,
    GET: `${BASE}service-point`,
    GET_ALL: `${BASE}service-point`,
    DELETE: `${BASE}service-point`,
    PUT: `${BASE}service-point`,
    CREATE_SELF_SERVICE_ACTIVATION_CODE: (servicePointId: number) =>
      `${BASE}service-point/${servicePointId}/self-service/activation-code`,
    REVOKE_SELF_SERVICE: (servicePointId: number) =>
      `${BASE}service-point/${servicePointId}/self-service/revoke`,
    ACTIVATE_SELF_SERVICE: (slug: string) => `/${slug}${BASE}service-point/self-service/activate`,
    GET_SELF_SERVICE_SESSION: (slug: string) => `/${slug}${BASE}service-point/self-service/session`,
  },

  TIME_CLOCK: {
    ME: `${BASE}time-clock/me`,
    ME_PUNCH: `${BASE}time-clock/me/punch`,
    ME_REPORT: (startDate: string, endDate: string) =>
      `${BASE}time-clock/me/report?startDate=${startDate}&endDate=${endDate}`,
    ME_ADJUSTMENTS: `${BASE}time-clock/me/adjustments`,
    MANAGEMENT: `${BASE}time-clock/management`,
    MANAGEMENT_SETTINGS: `${BASE}time-clock/management/settings`,
    MANAGEMENT_SCHEDULES: `${BASE}time-clock/management/schedules`,
    MANAGEMENT_PIN: `${BASE}time-clock/management/pin`,
    MANAGEMENT_ENTRIES: (startDate: string, endDate: string, employeeId?: string) => {
      const employee = employeeId ? `&employeeId=${encodeURIComponent(employeeId)}` : ""
      return `${BASE}time-clock/management/entries?startDate=${startDate}&endDate=${endDate}${employee}`
    },
    MANAGEMENT_REVIEW_ENTRY: (id: number) => `${BASE}time-clock/management/entries/${id}/review`,
    MANAGEMENT_LIVE: `${BASE}time-clock/management/live`,
    MANAGEMENT_ADJUSTMENTS: (status?: string, employeeId?: string) => {
      const filters = [
        status ? `status=${status}` : "",
        employeeId ? `employeeId=${encodeURIComponent(employeeId)}` : "",
      ].filter(Boolean)

      return `${BASE}time-clock/management/adjustments${filters.length ? `?${filters.join("&")}` : ""}`
    },
    MANAGEMENT_CREATE_ADJUSTMENT: `${BASE}time-clock/management/adjustments`,
    MANAGEMENT_REVIEW_ADJUSTMENT: (id: number) => `${BASE}time-clock/management/adjustments/${id}/review`,
    MANAGEMENT_REPORT: (employeeId: string, startDate: string, endDate: string) =>
      `${BASE}time-clock/management/report?employeeId=${encodeURIComponent(employeeId)}` +
      `&startDate=${startDate}&endDate=${endDate}`,
    MANAGEMENT_REPORT_PDF: (employeeId: string, startDate: string, endDate: string) =>
      `${BASE}time-clock/management/report/pdf?employeeId=${encodeURIComponent(employeeId)}` +
      `&startDate=${startDate}&endDate=${endDate}`,
    MANAGEMENT_REPORT_CSV: (startDate: string, endDate: string, employeeId?: string) => {
      const employee = employeeId ? `&employeeId=${encodeURIComponent(employeeId)}` : ""
      return `${BASE}time-clock/management/report/csv?startDate=${startDate}&endDate=${endDate}${employee}`
    },
    MANAGEMENT_LABOR_COST: (startDate: string, endDate: string) =>
      `${BASE}time-clock/management/labor-cost?startDate=${startDate}&endDate=${endDate}`,
    MANAGEMENT_QR_CODE: `${BASE}time-clock/management/qr-code`,
    PUBLIC_QR_CODE: (slug: string) => `/${slug}${BASE}time-clock/qr-code/public`,
  },

  CHECKLIST: {
    ME: `${BASE}checklists/me`,
    ME_START_EXECUTION: (templateId: number) => `${BASE}checklists/me/executions/${templateId}`,
    ME_EXECUTION: (id: number) => `${BASE}checklists/me/executions/${id}`,
    ME_UPDATE_STEP: (id: number, stepId: number) => `${BASE}checklists/me/executions/${id}/steps/${stepId}`,
    ME_COMPLETE_EXECUTION: (id: number) => `${BASE}checklists/me/executions/${id}/complete`,
    SECTORS: `${BASE}checklists/sectors`,
    SECTOR: (id: number) => `${BASE}checklists/sectors/${id}`,
    TEMPLATES: (includeInactive?: boolean) =>
      `${BASE}checklists/templates${includeInactive ? "?includeInactive=true" : ""}`,
    TEMPLATE: (id: number) => `${BASE}checklists/templates/${id}`,
    TEMPLATE_DUPLICATE: (id: number) => `${BASE}checklists/templates/${id}/duplicate`,
    TEMPLATE_ACTIVATE: (id: number) => `${BASE}checklists/templates/${id}/activate`,
    TEMPLATE_DEACTIVATE: (id: number) => `${BASE}checklists/templates/${id}/deactivate`,
    EXECUTION: (id: number) => `${BASE}checklists/executions/${id}`,
    EXECUTION_PDF: (id: number) => `${BASE}checklists/executions/${id}/pdf`,
    HISTORY: (startDate: string, endDate: string, templateId?: number, sectorId?: number, employeeId?: string) => {
      const filters = [
        templateId ? `templateId=${templateId}` : "",
        sectorId ? `sectorId=${sectorId}` : "",
        employeeId ? `employeeId=${encodeURIComponent(employeeId)}` : "",
      ].filter(Boolean)

      return `${BASE}checklists/history?startDate=${startDate}&endDate=${endDate}` +
        (filters.length ? `&${filters.join("&")}` : "")
    },
    HISTORY_PDF: (startDate: string, endDate: string, templateId?: number, sectorId?: number) => {
      const filters = [
        templateId ? `templateId=${templateId}` : "",
        sectorId ? `sectorId=${sectorId}` : "",
      ].filter(Boolean)

      return `${BASE}checklists/history/pdf?startDate=${startDate}&endDate=${endDate}` +
        (filters.length ? `&${filters.join("&")}` : "")
    },
  },

  REGISTER: {
    GET_ALL: `${BASE}register`,
  },
}
